import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import { MapPin, ExternalLink } from "lucide-react";

// Small, standalone map used on the Vitrine and the AI-generated public site
// to show candidates exactly WHERE the business is located. Fixed height,
// no clustering, no filters — just a single labelled pin.
const PIN_ICON = L.divIcon({
  className: "",
  html: '<div style="display:flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:9999px;background:#F97316;color:#fff;font-size:16px;box-shadow:0 4px 12px rgba(249,115,22,0.45);border:3px solid #fff">📍</div>',
  iconSize: [34, 34],
  iconAnchor: [17, 17],
});

export default function LocationMap({ lat, lng, name, address, city, country, accent = "#F97316", lang = "fr" }) {
  if (typeof lat !== "number" || typeof lng !== "number") return null;

  const fullAddress = [address, city, country].filter(Boolean).join(", ");
  const gmapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress || `${lat},${lng}`)}`;

  return (
    <div data-testid="location-map" className="rounded-2xl overflow-hidden border border-slate-200 bg-white">
      <div className="h-64 md:h-72 w-full relative">
        <MapContainer
          center={[lat, lng]}
          zoom={15}
          scrollWheelZoom={false}
          style={{ height: "100%", width: "100%" }}
          attributionControl={false}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker position={[lat, lng]} icon={PIN_ICON} />
        </MapContainer>
      </div>
      <div className="p-4 flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-start gap-2 min-w-0">
          <MapPin className="w-4 h-4 mt-0.5 shrink-0" style={{ color: accent }} />
          <div className="min-w-0">
            <p className="text-sm font-semibold text-slate-900 truncate">{name}</p>
            <p className="text-xs text-slate-500 truncate">{fullAddress}</p>
          </div>
        </div>
        <a
          data-testid="open-in-maps"
          href={gmapsUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-full text-white shrink-0"
          style={{ backgroundColor: accent }}
        >
          <ExternalLink className="w-3 h-3" /> {lang === "fr" ? "Itinéraire" : "Directions"}
        </a>
      </div>
    </div>
  );
}
